import SVG from '../assets/Xero-Connect-Buttons/connect-blue.svg?react';

export function XeroConnectButtonBlue(props) {
  return (
    <button
      data-cy={ `xero-connect-button-1` }
      type={ `button` }
      { ...props }
    >
      <SVG />
    </button>
  );
}
